import { Eye, EyeClosed } from '@phosphor-icons/react';
import { useState } from 'react';
import { Input, InputProps } from './Input';

export const PasswordInput = (props: InputProps) => {
  const [inputType, setInputType] = useState('password');
  return (
    <Input
      {...props}
      type={inputType}
      icon={
        inputType === 'password' ? (
          <Eye className={props.className} size={20} />
        ) : (
          <EyeClosed className={props.className} size={20} />
        )
      }
      iconAction={() =>
        inputType === 'password'
          ? setInputType('text')
          : setInputType('password')
      }
    />
  );
};
